var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item px-4 px-sm-4 px-lg-5 pv3"},[_c(_vm.template,{tag:"div",attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }